<template src="./index.html"></template>

<script>
	import {
		getdata
	} from './data.js';
	import axios from 'axios'
	export default {
		data() {
			return {
				qrCode: "",
				refreshDate: "",
				kpr: ""
			};
		},
		mounted() {
			if (this.$route.query.id) {
				var token = localStorage.getItem('token')
				if (token == "" || token == null) {
					localStorage.setItem('token', " ");
				}
				const formData = new FormData()
				formData.append('id', this.$route.query.id)
				formData.append('refresh', false)
				this.$https.fetchPost('/rpa/authentication/getQrCode/v2', formData).then(res => {
					if (res.data.code == 200) {
						this.refreshDate = res.data.data.qrCodeTime;
						this.qrCode = res.data.data.qrCode;
						this.kpr = res.data.data.loginAccount
					} else {
						this.$message.error(res.data.message);
						this.refreshDate = "";
						this.qrCode = "";
						this.kpr = "";
					}
				})
			}
		},
		created() {

		},
		methods: {
			//刷新二维码
			refreshQrCode() {
				if (this.$route.query.id) {
					var token = localStorage.getItem('token')
					if (token == "" || token == null) {
						localStorage.setItem('token', " ");
					}
					const formData = new FormData()
					formData.append('id', this.$route.query.id)
					formData.append('refresh', true)
					this.$https.fetchPost('/rpa/authentication/getQrCode/v2', formData).then(res => {
						if (res.data.code == 200) {
							this.$message.success("刷新成功");
							this.refreshDate = res.data.data.qrCodeTime;
							this.qrCode = res.data.data.qrCode;
							this.kpr = res.data.data.loginAccount
						} else {
							this.$message.error(res.data.message);
							this.refreshDate = "";
							this.qrCode = "";
							this.kpr = "";
						}
					})
				}

			},
			getDate() {
				let date = new Date();
				return date.getFullYear() + '-' +
					('0' + (date.getMonth() + 1)).slice(-2) + '-' +
					('0' + date.getDate()).slice(-2) + ' ' +
					('0' + date.getHours()).slice(-2) + ':' +
					('0' + date.getMinutes()).slice(-2) + ':' +
					('0' + date.getSeconds()).slice(-2);

			},
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
</style>